// 活动 tb_activity Mock（管理后台用），字段严格对齐 docs/项目数据库文档.md
// 状态：0草稿 1报名中 2进行中 3已结束
// 时间类型 time_type：1日期范围 2特定一天
// flows 对应 MongoDB 集合 mg_activity_flows：一天一条文档 { flow_date, nodes[] }
// nodes[] = { start_time, end_time, title, description, extra }
export const ACTIVITY_LIST = [
  {
    id: 1,
    company_id: 0,
    name: '圣山塔林姓氏源流文化节',
    category: 'surname',
    img_landscape: '',
    img_portrait: '',
    overview: '邀请姓氏文化研究学者与宗亲后裔，共溯同源根脉，弘扬家风家训',
    intro: '<h3>活动简介</h3><p>本活动邀请多位姓氏文化研究学者现场讲解姓氏源流，并通过宗亲后裔访谈、家风家训展演等形式，弘扬中华传统文化。</p>',
    time_type: 1,
    start_date: '2026-10-01',
    end_date: '2026-10-03',
    start_time: '09:00',
    end_time: '17:00',
    place_name: '圣山塔林景区·主会场',
    province: '广西壮族自治区',
    city: '桂林市',
    district: '阳朔县',
    address: '阳朔镇抗战路 66 号',
    lat: 24.7785,
    lng: 110.4966,
    created_at: '2026-08-15 09:30:00',
    updated_at: '2026-09-08 16:20:00',
    status: 1,
    sort: 1,
    flows: [
      {
        flow_date: '2026-10-01',
        nodes: [
          { start_time: '09:00', end_time: '09:30', title: '签到集合', description: '最东红门集合，领取活动手册', extra: '地点：景区东门' },
          { start_time: '09:40', end_time: '11:40', title: '游览景区', description: '塔林核心区参观', extra: '' },
          { start_time: '14:00', end_time: '16:30', title: '姓氏讲座', description: '姓氏文化源流讲解', extra: '讲师：雷晶教授' }
        ]
      },
      {
        flow_date: '2026-10-02',
        nodes: [
          { start_time: '09:30', end_time: '11:30', title: '家谱编修工作坊', description: '分组实操，带来自家老谱现场答疑', extra: '物料：宣纸、毛笔' }
        ]
      }
    ]
  },
  {
    id: 2,
    company_id: 0,
    name: '王氏宗祠寻根祭祖大典',
    category: 'ancestral',
    img_landscape: '',
    img_portrait: '',
    overview: '王氏宗亲齐聚圣山脚下，祭拜先祖、共议家训',
    intro: '<p>活动包括祭祖仪式、家训诵读、宗亲合影留念等环节</p>',
    time_type: 2,
    start_date: '2026-10-15',
    end_date: '',
    start_time: '09:30',
    end_time: '15:30',
    place_name: '桂林王氏宗祠',
    province: '广西壮族自治区',
    city: '桂林市',
    district: '七星区',
    address: '穿山路 88 号',
    lat: 25.2740,
    lng: 110.3170,
    created_at: '2026-09-01 10:00:00',
    updated_at: '2026-09-05 14:00:00',
    status: 3,
    sort: 2,
  },
  {
    id: 3,
    company_id: 0,
    name: '塔林石刻艺术研学营',
    category: 'talin_study',
    img_landscape: '',
    img_portrait: '',
    overview: '深入塔林核心区，由专家讲解石刻艺术与历史价值',
    intro: '<p>面向青少年的研学营，由博物馆研究员带队，结合实地参观与讲座</p>',
    time_type: 1,
    start_date: '2026-09-20',
    end_date: '2026-09-25',
    start_time: '08:30',
    end_time: '16:30',
    place_name: '塔林博物馆',
    province: '广西壮族自治区',
    city: '桂林市',
    district: '阳朔县',
    address: '塔林路 1 号',
    lat: 24.7800,
    lng: 110.5000,
    created_at: '2026-08-20 11:00:00',
    updated_at: '2026-09-02 09:15:00',
    status: 2,
    sort: 3,
    flows: [
      {
        flow_date: '2026-09-20',
        nodes: [
          { start_time: '08:30', end_time: '09:00', title: '开营签到', description: '博物馆门口集合，发放研学手册', extra: '' },
          { start_time: '09:10', end_time: '11:30', title: '石刻艺术讲座', description: '塔林石刻的历史分期与艺术特征', extra: '讲师：博物馆研究员' },
          { start_time: '14:00', end_time: '16:30', title: '实地拓印体验', description: '在指导下完成一幅石刻拓片', extra: '物料：宣纸、墨、拓包' }
        ]
      },
      {
        flow_date: '2026-09-21',
        nodes: [
          { start_time: '09:00', end_time: '11:30', title: '塔林核心区考察', description: '分组记录石刻铭文', extra: '' }
        ]
      }
    ]
  },
  {
    id: 4,
    company_id: 0,
    name: '中秋姓氏家宴体验日',
    category: 'folk_custom',
    img_landscape: '',
    img_portrait: '',
    overview: '姓氏家宴 + 月饼手作 + 古礼拜月，让参与者体验传统民俗',
    intro: '<p>分姓氏分组落座，每桌推出本姓传统家宴菜谱</p>',
    time_type: 2,
    start_date: '2026-09-15',
    end_date: '',
    start_time: '18:00',
    end_time: '21:00',
    place_name: '塔林山庄',
    province: '广西壮族自治区',
    city: '桂林市',
    district: '阳朔县',
    address: '塔林路 8 号',
    lat: 24.7820,
    lng: 110.4980,
    created_at: '2026-08-25 15:30:00',
    updated_at: '2026-09-08 10:30:00',
    status: 1,
    sort: 4,
  },
  {
    id: 5,
    company_id: 0,
    name: '家谱编修入门讲座',
    category: 'genealogy',
    img_landscape: '',
    img_portrait: '',
    overview: '面向普通宗亲的家谱编修入门指南，含工具、流程、常见误区',
    intro: '<p>由资深家谱编修师讲解，从收集资料到成书的一整套流程</p>',
    time_type: 2,
    start_date: '2026-09-30',
    end_date: '',
    start_time: '14:00',
    end_time: '17:00',
    place_name: '桂林文化中心',
    province: '广西壮族自治区',
    city: '桂林市',
    district: '象山区',
    address: '中山中路 102 号',
    lat: 25.2745,
    lng: 110.2900,
    created_at: '2026-09-05 13:20:00',
    updated_at: '2026-09-09 17:00:00',
    status: 0,
    sort: 5,
  }
]

// 状态文本/颜色映射（前端复用）
export const ACTIVITY_STATUS = [
  { value: 0, label: '草稿',   tagType: 'info' },
  { value: 1, label: '报名中', tagType: 'primary' },
  { value: 2, label: '进行中', tagType: 'success' },
  { value: 3, label: '已结束', tagType: 'warning' }
]

export const ACTIVITY_TIME_TYPE = [
  { value: 1, label: '日期范围' },
  { value: 2, label: '特定一天' }
]

export function activityStatusText(value) {
  const item = ACTIVITY_STATUS.find(s => s.value === value)
  return item ? item.label : '—'
}
export function activityStatusTagType(value) {
  const item = ACTIVITY_STATUS.find(s => s.value === value)
  return item ? item.tagType : 'info'
}
export function activityTimeTypeLabel(value) {
  const item = ACTIVITY_TIME_TYPE.find(t => t.value === value)
  return item ? item.label : '—'
}